import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import Modal from 'react-bootstrap/Modal';
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Company from "./Company";
import Airport from "./Airport";
import BankAccount from "./BankAccount";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Switch from "@mui/material/Switch";
import { Grid, Input, MenuItem, Select, InputLabel } from "@mui/material";
import { Divider, Button } from "@mui/material";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import BusinessIcon from '@mui/icons-material/Business';
import LocalAirportIcon from "@mui/icons-material/LocalAirport";
import Profile from "../Profile";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import TabPanel from "../../TabPanel";

const ParameterModal = (props) => {

  const [tabValue, setTabValue] = React.useState(0);
  const { user: currentUser } = useSelector((state) => state.auth);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Modal
      {...props}

      disableAutoFocus={true}
      disableEnforceFocus={true}

      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >

      <Modal.Header closeButton>
        <Grid container>
          <Grid item>
            <Modal.Title>Settings</Modal.Title>
          </Grid>
        </Grid>
      </Modal.Header>

      <Modal.Body>
        <Grid item xs={12}>

          {currentUser && currentUser.type == 1 ?
            <Tabs value={tabValue} onChange={handleTabChange} centered>
              <Tab icon={<ManageAccountsIcon />} aria-label="ManageAccounts" />
              <Tab icon={<BusinessIcon />} aria-label="Business" />
              <Tab icon={<LocalAirportIcon />} aria-label="LocalAirport" />
              <Tab icon={<AccountBalanceIcon />} aria-label="BankAccounts" />
            </Tabs> : <>
              <Tabs value={tabValue} onChange={handleTabChange} centered>
                <Tab icon={<ManageAccountsIcon />} aria-label="ManageAccounts" />
              </Tabs></>}


          {currentUser ? <>{currentUser.type == 1 ? <>
            <TabPanel value={tabValue} index={0} height={600}>
              <Profile />
            </TabPanel>
            <TabPanel value={tabValue} index={1} height={600}>
              <Company />
            </TabPanel>
            <TabPanel value={tabValue} index={2} height={600}>
              <Airport />
            </TabPanel>
            <TabPanel value={tabValue} index={3} height={600}>
              <BankAccount />
            </TabPanel></> :
            <>
              <TabPanel value={tabValue} index={0} height={600}>
                <Profile />
              </TabPanel></>}</> : <></>}



        </Grid>
      </Modal.Body>



    </Modal>
  );
};

export default ParameterModal;